import { Component, h, State } from '@stencil/core';
import '../sspb-probono-catalog/src/components/probono-catalog/probono-catalog';

@Component({
  tag: 'app-root',
  styleUrl: 'app-root.css',
  shadow: true,
})
export class AppRoot {
  @State() cohortId: string = '0';
  @State() partnerId: string = '';
  @State() firstRun: boolean = true;
  @State() initializing: boolean = true;
  @State() insufficientData: boolean = false;

  componentWillLoad() {
    this.handleRouteChange(window.location.href.toString().split(window.location.host)[1])
  }

  handleRouteChange (path) {
    let pathArray = path.split('/');
    console.log(pathArray);

    if (((pathArray[1] === 'cohort') && (pathArray.length < 4))  || ((pathArray[1] === 'cohort') && (pathArray[3] === 'partner'))) {
        this.cohortId = pathArray[2];
        this.partnerId = pathArray[4];

        console.log(`Updated cohortId: ${this.cohortId}, partnerId: ${this.partnerId}`);

        this.initializing = false;
    } else {
      this.insufficientData = true;
    }
  }

  render() {
    let partnerAttribute = {};

    if (this.partnerId !== '') {
      partnerAttribute["partner-id"] = this.partnerId;
    }

    if (this.insufficientData) {
      return (
        <div class="app-home">Invalid Cohort ID Providied.  Please provide the ID of a cohort you're interested in.</div>
      );
    } else if (this.initializing) {
      return (
        <div class="app-home">Loading catalog... please wait one moment.</div>
      );
    } else {
      return (
        <div class="app-home">
          <probono-catalog cohort-id={this.cohortId} {...partnerAttribute}/>
        </div>
      );
    }
  }
}
